import React from 'react';
import PropTypes from 'prop-types';

import ImgWithFallback from './ImgWithFallback';

const REPLACE_MAP = {
  n: 's',
  s: 'n',
};
const GRAPH_REGEX = /\/graph\/([ns])\//;

function getFallbackSrc(src) {
  if (!src) {
    return null;
  }

  if (!src.match(GRAPH_REGEX)) {
    return null;
  }

  return (String(src)).replace(GRAPH_REGEX, function (match, letter) {
    return `/graph/${REPLACE_MAP[letter]}/`;
  });
}

export default function ImgNS({ src, alt, ...rest }) {
  const fallbackSrc = getFallbackSrc(src);

  return (
    <ImgWithFallback src={src} alt={alt} {...rest} fallbackSrc={fallbackSrc} />
  );
}

ImgNS.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
};
